const  apiKey = "AIzaSyALb15PO9M7sgx4H59M2svAMjv7oHT6VRY";
export default apiKey;